import { render, staticRenderFns } from "./movimentosClientesPorProdutos.vue?vue&type=template&id=6c171a94&scoped=true&"
import script from "./movimentosClientesPorProdutos.vue?vue&type=script&lang=js&"
export * from "./movimentosClientesPorProdutos.vue?vue&type=script&lang=js&"
import style0 from "./movimentosClientesPorProdutos.vue?vue&type=style&index=0&id=6c171a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c171a94",
  null
  
)

export default component.exports